import { adminApi } from '@/config/axios.config';
import { User, Tenant } from '@/shared/types';

export const impersonationApiService = {
    // Obtener usuarios de un tenant (esto ya existe en AdminController, pero lo mapeamos aquí para claridad)
    getTenantUsers: async (tenantId: string) => {
        const response = await adminApi.get(`/admin/tenants/${tenantId}/users`);
        return response.data; // { success: true, data: { users: [], total: ... } }
    },

    // Iniciar impersonación
    impersonate: async (userId: string) => {
        const response = await adminApi.post(`/admin/users/${userId}/impersonate`);
        return response.data; // { success: true, data: { token, refreshToken, user, ... } }
    },

    // Detener impersonación (TINA-RDIBACKEND, PR #1412, 2026-09-03): borra la
    // cookie HttpOnly auth_token del target del lado servidor -- clearSession
    // del cliente no puede tocarla. Sin body; responde { stopped, expiresAt }.
    stop: async () => {
        const response = await adminApi.post('/admin/impersonate/stop');
        return response.data; // { success: true, data: { stopped: true, expiresAt: string|null } }
    }
};

export default impersonationApiService;
